import React from "react";
import { DailyExportsColumnHeader, WarehouseCheckInFileType } from "src/enums";
import { TableColumn, ExportFileData } from "src/types";
import { FileDownloadButton } from "src/components";
import { Table } from "src/components";

interface GoodsInExportsTableProps {
  data: ExportFileData[];
  downloadFile: (params: { exportFileId: string; type: WarehouseCheckInFileType.GOODS_IN_EXPORTS }) => void;
  isFileDownloading?: boolean;
}

const GoodsInExportsTable: React.FC<GoodsInExportsTableProps> = ({ data, downloadFile, isFileDownloading }) => {
  const columns: TableColumn<DailyExportsColumnHeader, ExportFileData>[] = [
    {
      header: DailyExportsColumnHeader.DATE,
      column: (row) => <span className="text-sm font-medium text-secondary-900">{row.date}</span>,
      styles: { minWidth: "200px" }
    },
    {
      header: DailyExportsColumnHeader.DOWNLOAD,
      column: (row) => (
        <div className="flex justify-center">
          <FileDownloadButton
            handleDownload={() =>
              downloadFile({ exportFileId: row.fileName, type: WarehouseCheckInFileType.GOODS_IN_EXPORTS })
            }
            isDisabled={isFileDownloading}
            buttonText="Download"
          />
        </div>
      ),
      styles: { minWidth: "150px", textAlign: "center" }
    }
  ];

  return <Table<DailyExportsColumnHeader, ExportFileData> data={data} columns={columns} />;
};

export { GoodsInExportsTable };
